import loadKit from "@godweb/promos-base/src/config/loadKit";
import i18n from "@godweb/promos-base/src/js/localization/Localization";
import Vue from "vue";
import Vuex from "vuex";
import App from "./App";
import store from "./store/index";
import EventBroker from "@godweb/frontend-base/src/libs/event-broker/EventBroker";
import registerApiServices from "@/api/registerApiServices";
import api from "@godweb/frontend-base/src/libs/api/Api";

Vue.use(Vuex);
Vue.config.productionTip = false;
Vue.prototype.$api = window.api = api;
Vue.prototype.$eventBroker = window.eventBroker = new EventBroker();

loadKit();
registerApiServices();

new Vue({
  components: {App},
  mounted() {
    const INIT_VUE_COMPONENTS = new Event("init_vue_components");
    document.dispatchEvent(INIT_VUE_COMPONENTS);
  },
  render: (h) => h(App),
  i18n,
  store,
}).$mount("#app");
